let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ggA0n")).then(() => parcelRequire('1lutJ'));